<template>
  <va-card :title="$t('menu.ranking')">
    <div class="flex xs12 sm3">
      <va-date-picker
        :label="$t('tables.date')"
        v-model="datepicker.today"
        :config="{mode: 'multiple'}"
      />
    </div>

    <!-- <va-modal
      v-model="showModal"
      size="large"
      :title=" $t('modal.largeTitle') "
      :message=" $t('modal.message') "
      :cancelText=" $t('modal.cancel') "
    /> -->

    <va-data-table
      :fields="fields"
      :data="data"
      :loading="loading"
      no-pagination
    >
    </va-data-table>
  </va-card>
</template>

<script>

import RankingAPI from '@/services/RankingAPI'
import moment from 'moment'

export default {
  name: 'modals',
  data () {
    return {
      data: [],
      loading: false,
      datepicker: {
        today: moment(new Date()).format('DD/MM/YYYY')
      },
      showModal: false,
    }
  },
  mounted () {
    var self = this
    RankingAPI.getRanking().then(response => {
      self.data = response.data
    })
  },
  updated () {
    var self = this
    RankingAPI.getRanking().then(response => {
      self.data = response.data
    })
  },
  computed: {
    fields () {

      return [{
        name: 'position',
        title: this.$t('tables.ranking.position'),
        width: '3%',
      },
      {
        name: 'name',
        title: this.$t('tables.ranking.name'),
        width: '20%',
      },
      {
        name: 'quantity_box',
        title: this.$t('tables.ranking.quantity_box'),
        width: '10%',
      },
      {
        name: 'box_per_hour',
        title: this.$t('tables.ranking.box_per_hour'),
        width: '10%',
      },
      {
        name: 'quantity_total',
        title: this.$t('tables.ranking.quantity_total'),
        width: '10%',
      },
      {
        name: 'box_per_pallet',
        title: this.$t('tables.ranking.box_per_pallet'),
        width: '10%',
      },
      {
        name: 'quantity_errors',
        title: this.$t('tables.works.quantity_errors'),
        width: '10%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  filters: {
    moment: function (delivery_date) {
      return moment(delivery_date).format('YYYY-MM-DD');
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    updateShowModal(boolean) {
      this.showModal = boolean
    }
  },
}
</script>

<style lang="scss">
</style>
